import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import FooterBlack from "components/Footers/FooterBlack.js";

function ContactUs() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="edge-page">
      <div className="edge-page-brand-nav">
        <Container>
          <Link to="/presentation">Edge<span>Ventures</span></Link>
        </Container>
      </div>
      <section className="edge-page-hero">
        <Container>
          <span className="edge-page-eyebrow">{"// get in touch"}</span>
          <h1 className="edge-page-title">
            Let's <span>Talk</span>
          </h1>
          <p className="edge-page-subtitle">
            Available for consulting engagements, app development projects, and
            AI automation work. Based in Los Angeles — working with clients
            globally.
          </p>
        </Container>
      </section>

      <section className="edge-page-body">
        <Container>
          <Row>
            <Col md="5">
              <div style={{ marginBottom: "40px" }}>
                <span className="ep-section-eyebrow">Direct</span>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "8px" }}>
                  <div className="edge-stub-card" style={{ textAlign: "left", padding: "24px 28px" }}>
                    <p style={{ margin: 0, fontSize: "0.8rem", color: "var(--ep-muted)", fontFamily: "'Fira Code', monospace", letterSpacing: "0.1em", marginBottom: "8px" }}>PHONE</p>
                    <a href="tel:+13232066068" style={{ color: "var(--ep-text)", fontSize: "1.1rem", fontWeight: 600, textDecoration: "none" }}>
                      (323) 206-6068
                    </a>
                  </div>
                  <div className="edge-stub-card" style={{ textAlign: "left", padding: "24px 28px" }}>
                    <p style={{ margin: 0, fontSize: "0.8rem", color: "var(--ep-muted)", fontFamily: "'Fira Code', monospace", letterSpacing: "0.1em", marginBottom: "8px" }}>EMAIL</p>
                    <a href="mailto:don@edgeventures.ai" style={{ color: "var(--ep-text)", fontSize: "1.1rem", fontWeight: 600, textDecoration: "none" }}>
                      don@edgeventures.ai
                    </a>
                  </div>
                  <div className="edge-stub-card" style={{ textAlign: "left", padding: "24px 28px" }}>
                    <p style={{ margin: 0, fontSize: "0.8rem", color: "var(--ep-muted)", fontFamily: "'Fira Code', monospace", letterSpacing: "0.1em", marginBottom: "8px" }}>LOCATION</p>
                    <span style={{ color: "var(--ep-text)", fontSize: "1.1rem", fontWeight: 600 }}>
                      Los Angeles, CA
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col md="7">
              <div className="edge-stub-card" style={{ textAlign: "left" }}>
                <div className="edge-stub-icon" style={{ margin: "0 0 24px" }}>
                  <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                </div>
                <h3>Contact form coming soon</h3>
                <p>
                  A proper contact form is on its way. For now, use the phone or
                  email above — or use the chat widget in the corner to start a
                  conversation right now.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <FooterBlack />
    </div>
  );
}

export default ContactUs;
